import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";

export const KpiCards = ({ data }: { data?: any }) => {
  console.log("KPI Cards Data:", data);
const stats = [
  {
    title: "Completion Rate",
    count: data?.metricsPercentages?.completionRate ?? 0,
    tooltip: (
      <div className="text-sm max-w-xs leading-snug">
        <p>
          Percent of scheduled meters completed this cycle. Aim to keep this above 90% consistently. Use this to spot delays and reassign workload.
        </p>
        <p className="mt-2">
          <strong>Optimization:</strong> Balance routes by meter count and distance to reduce unfinished work.
        </p>
      </div>
    ),
  },
  {
    title: "On-Time Completion",
    count: data?.onTimeCompletionRate ?? 0,
    tooltip: (
      <div className="text-sm max-w-xs leading-snug">
        <p>
           Percent of meters completed on or before their due date. Use to evaluate scheduling efficiency.
        </p>
        <p className="mt-2">
          <strong>Optimization:</strong> Prioritize due-soon meters and adjust field routes when lags appear.
        </p>
      </div>
    ),
  },
  {
    title: "Reading Accuracy",
    count: data?.metricsPercentages?.readingAccuracy ?? 0,
    tooltip: (
      <div className="text-sm max-w-xs leading-snug">
        <p>
         Percent of validated readings without corrections or flags. Use to monitor data quality by reader and device type.
        </p>
        <p className="mt-2">
          <strong>Optimization:</strong> Coach readers with low accuracy and review faulty devices.
        </p>
      </div>
    ),
  },
  {
    title: "Avg. Reading Time",
    count: data?.avgReadingTime ?? "NA",
    tooltip: (
      <div className="text-sm max-w-xs leading-snug">
        <p>
           Average duration to capture a reading. High values indicate travel or access issues.
        </p>
        <p className="mt-2">
          <strong>Optimization:</strong> Cluster nearby premises and flag locations with repeated access delays.
        </p>
      </div>
    ),
  },
];


  return (
    <div>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
        {stats.map((item, index) => (
          <QuickStatsCard
            key={index}
            title={item.title}
            count={ item.count}
            tooltip={item.tooltip}
            trendSummary=""
          />
        ))}
      </div>
    </div>
  );
};
